module.exports = __webpack_public_path__ + "static/media/six2.02f7fcca.svg";